import { ClientType } from "api/public";
import { useProducts } from "contexts/ProductsContext";
import { useFeatureStatus } from "portal-ui-remote/FeatureStatusContext";
import { useUserState } from "portal-ui-remote/UserStateContext";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const CLIENT_TYPES_TO_EXCLUDE: ClientType[] = [
  "ClientProd",
  "ClientProspect",
  "CodatInternal",
  "CodatQATest",
  "ClientTest",
  "CodatSalesDemo",
];

export function useOnboarding() {
  const { products } = useProducts();
  const { search } = useLocation();
  const { featureStatus } = useFeatureStatus();
  const { userState } = useUserState();
  const hasQueryParam = search.toLowerCase().includes("firsttimeclient=true");

  const showOnboarding = useMemo(() => {
    const hasProductEnabled = products?.some(
      (product) => product.status === "Enabled"
    );

    const featureSwitchEnabled =
      featureStatus?.["PortalUI.OnboardingMandatory"];
    const isExcludedClientType =
      userState?.clientType &&
      CLIENT_TYPES_TO_EXCLUDE.includes(userState?.clientType);

    if (hasQueryParam) {
      return true;
    }
    if (
      !products ||
      products?.length === 0 ||
      !userState ||
      isExcludedClientType ||
      !featureSwitchEnabled
    ) {
      return false;
    }
    if (!hasProductEnabled) {
      return true;
    }
    return false;
  }, [products, featureStatus, hasQueryParam, userState]);

  return showOnboarding;
}
